import { v4 as uuidv4 } from "uuid";

/**
 * Returns true when a peaks JSON file exists at the given path.
 * @param {string} peaksPath
 * @returns {boolean}
 */
export function peaksFileExists(peaksPath) {
    if (!peaksPath || typeof window.fsSync?.existsSync !== "function") {
        return false;
    }

    try {
        return window.fsSync.existsSync(peaksPath);
    } catch {
        return false;
    }
}

/**
 * Generates waveform peak data for a local media file using the audioExtraction worker.
 * @param {object} media
 * @param {{ onProgress?: (message: string) => void }} [options]
 * @returns {Promise<string>} Resolves with the output JSON file path.
 */
export function generatePeaks(media, { onProgress } = {}) {
    return new Promise((resolve, reject) => {
        if (!media?.localPath) {
            reject(new Error("No local path available for peak generation"));
            return;
        }

        const outputPath =
            window.os.tmpdir() + window.path.sep + uuidv4() + ".json";
        const ffmpegPath = window.ffmpegPath?.replace?.(
            "app.asar",
            "app.asar.unpacked",
        );

        const worker = new Worker("./build/workers/audioExtraction.js");

        worker.postMessage({
            inputPath: media.localPath,
            outputPath,
            ffmpegPath,
            duration: media.info?.duration,
        });

        worker.onmessage = (msg) => {
            if (msg.data.status === "in_progress") {
                onProgress?.(msg.data.result);
                return;
            }

            worker.terminate();

            if (msg.data.error) {
                reject(new Error(msg.data.error));
                return;
            }

            resolve(outputPath);
        };

        worker.onerror = (err) => {
            worker.terminate();
            reject(err);
        };
    });
}
